import { LayoutGrid, List } from 'lucide-react';
import {
  VIEW_TOGGLE_BUTTON_ACTIVE,
  VIEW_TOGGLE_BUTTON_BASE,
  VIEW_TOGGLE_BUTTON_INACTIVE,
  VIEW_TOGGLE_GROUP,
} from './viewToggleTokens.js';

/**
 * Grid / List view toggle — Figma 7996:5370 (separate buttons, primary blue active).
 *
 * @example
 * <ViewToggle view={view} onChange={setView} />
 *
 * @example Custom options
 * <ViewToggle
 *   view={view}
 *   onChange={setView}
 *   options={[
 *     { value: 'grid', icon: LayoutGrid, label: 'Switch to grid view' },
 *     { value: 'list', icon: Table2, label: 'Switch to table view' },
 *   ]}
 *   ariaLabel="Result view"
 * />
 */

const DEFAULT_OPTIONS = [
  { value: 'list', icon: List, label: 'List view' },
  { value: 'grid', icon: LayoutGrid, label: 'Grid view' },
];

const ViewToggle = ({
  view,
  onChange,
  options = DEFAULT_OPTIONS,
  className = '',
  buttonClassName = '',
  ariaLabel = 'View mode',
  iconSize = 24,
}) => (
  <div
    role="group"
    aria-label={ariaLabel}
    className={[VIEW_TOGGLE_GROUP, className].filter(Boolean).join(' ')}
  >
    {options.map(({ value, icon: Icon, label }) => {
      const isActive = view === value;
      return (
        <button
          key={value}
          type="button"
          onClick={() => onChange(value)}
          aria-label={label}
          aria-pressed={isActive}
          className={[
            VIEW_TOGGLE_BUTTON_BASE,
            isActive ? VIEW_TOGGLE_BUTTON_ACTIVE : VIEW_TOGGLE_BUTTON_INACTIVE,
            buttonClassName,
          ]
            .filter(Boolean)
            .join(' ')}
        >
          <Icon size={iconSize} aria-hidden />
        </button>
      );
    })}
  </div>
);

export default ViewToggle;
